/* eslint-disable array-callback-return */
/* eslint-disable no-useless-computed-key */

import React, { Fragment, useState } from 'react';
import FilterIcon from "../../../../../../assets/images/icon_actions/Filter Icon.svg";
import { Popover, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import clsx from 'clsx';
import { Image } from "antd";
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import younoteAdminActions from "../../../../../YounoteAdmin/Product/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import crudActions from "../../../../../CRUD/redux/actions";
import RefreshIcon from "../../../../../../assets/images/refresh.svg";

export default function FilterView(props) {
    const { classes, clientProductcatalogueDetails, customObject, handleFilter, productGroupDetails, topBar } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [filter, setFilter] = useState({});
    const [lastData, setLastData] = useState('');
    const { getData } = useSelector(state => state.crudReducer);

    const { categoryDetails } = useSelector(state => state.younoteAdminProductReducer);

    const [categoryDropDown, setCategoryDropDown] = useState([]);
    const dispatch = useDispatch();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const changeHandler = (data, name) => {
        if (name === 'category') {
            if (data?.id) {
                const selectedIndex = categoryDropDown.findIndex((el) => el?.id === data?.parentId);
                categoryDropDown[selectedIndex + 1] = data;
                if (data?.hasSubCategories) {
                    categoryDropDown[selectedIndex + 2] = {};
                    categoryDropDown.length = selectedIndex + 3;
                    setLastData('');
                    dispatch({
                        type: crudActions.GET_DETAILS_START,
                        url: `/get-subcategories/${data?.id}`,
                    });
                } else {
                    categoryDropDown.length = selectedIndex + 2;
                    setLastData(data.id);
                }
                setCategoryDropDown([
                    ...categoryDropDown
                ]);
            }
        } else {
            setFilter({
                ...filter,
                [name]: data
            });
            dispatch({
                type: younoteAdminActions.CATEGORY_DETAILS_START,
                url: 'product-categories',
                filter: {
                    where: { ["and"]: [{ catalogueId: data.id }] }
                }
            });
            setCategoryDropDown([{}]);
        }

    }

    const handleFindProducts = () => {
        if (lastData) {
            handleFilter(filter?.catalogue?.id, [lastData]);
            setAnchorEl(null);
        } else {
            let d = categoryDropDown[categoryDropDown.length - 2];
            let dList = categoryDetails && categoryDetails.filter((el) => { return el.parentId === d?.id });
            let cIds = [d?.id];
            if (dList.length > 0) {
                getData?.length > 0 && getData?.map((item) => {
                    item["1evel3"] && item["1evel3"]?.map((item) => {
                        item["1evel4"] && item["1evel4"]?.map((item) => {
                            cIds.push(item.id);
                        });
                        cIds.push(item.id);
                    });
                    cIds.push(item.id);
                });
                handleFilter(filter?.catalogue?.id, cIds);
                setAnchorEl(null);
            } else {
                handleFilter(filter?.catalogue?.id, '');
                setAnchorEl(null);
            }
        }
    }

    const handleRefresh = () => {
        setFilter({});
        setLastData('');
        setAnchorEl(null);
        setCategoryDropDown([]);
        handleFilter('', '')
    }

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (
        <Fragment>
            <NavLink
                to="#"
                onClick={(e) => handleClick(e)}
                className={clsx(classes.customLink)}>
                <Image
                    src={FilterIcon}
                    preview={false}
                    className={clsx(classes.antImage)}
                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Filter</span>
            </NavLink>
            {
                topBar?.catalogueId ? <div className={clsx(classes.customLink, classes.resetLink)}>
                    <span className={clsx(classes.addLink, classes.bold)} title={topBar?.categoryIds ? customObject(categoryDetails, topBar?.categoryIds[0])?.categoryName : customObject(clientProductcatalogueDetails, topBar?.catalogueId)?.catalogueName}>
                        {
                            topBar?.categoryIds ? customObject(categoryDetails, topBar?.categoryIds[0])?.categoryName : customObject(clientProductcatalogueDetails, topBar?.catalogueId)?.catalogueName
                        }
                    </span>
                    <NavLink
                        to="#"
                        onClick={(e) => handleRefresh()}
                        className={clsx(classes.customLink)}>
                        <Image
                            src={RefreshIcon}
                            preview={false}
                            className={clsx(classes.antImage)}
                        />
                    </NavLink>
                </div> : ''
}
<Popover
    id={id}
    open={open}
    anchorEl={anchorEl}
    onClose={() => handleClose()}
    className={classes.filterViewPopover}
    //PaperProps={true}
    anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
    }}>
    <div className={classes.filterView}>
        <Typography variant={'h6'} className={clsx(classes.fonSize14, classes.bold, classes.positionRelative)}><span>
            {
                topBar?.groupId ? customObject(productGroupDetails, topBar?.groupId)?.name : 'All Products'
            }
        </span>
            {
                ((categoryDropDown && categoryDropDown?.length > 0 && categoryDropDown[0]?.id) || filter?.catalogue?.id) ? <NavLink to={'#'} onClick={() => handleRefresh()} className={clsx(classes.customLink, classes.bold, classes.textAlignRight, classes.cursor)}>
                    <Image src={RefreshIcon} className={classes.catalogueRefresh} preview={false} /> <span>Filter Reset</span></NavLink> :
                    <NavLink to={'#'} variant={'h6'} className={clsx(classes.disabled, classes.customLink, classes.bold, classes.textAlignRight, classes.cursor)}>
                        <Image src={RefreshIcon} className={classes.catalogueRefresh} preview={false} /><span>Filter Reset</span></NavLink>
            }
        </Typography>
        <div className={clsx(classes.categoryDropDownScroll)}>
            <Typography variant={'h6'} className={clsx(classes.addressSmall, classes.margin15t, classes.bold)}><span>Filter</span></Typography>
            <AutoCompleteComponent
                customLabel={"Please Select Catalogue"}
                heads={[{ 'key': 'catalogueName', 'name': 'Name' },
                { 'key': 'cataloguePrefix', 'name': 'Prefix' }]}
                details={clientProductcatalogueDetails}
                parentValue={customObject(clientProductcatalogueDetails, filter?.catalogue?.id)}
                position={"top"}
                variant={'outlined'}
                customClasses={clsx(classes.margin20t)}
                onChange={(data) => changeHandler(data, 'catalogue')}
            />
            {
                categoryDropDown.length > 0 && categoryDropDown.map((data, i) => (
                    <AutoCompleteComponent
                        customLabel={i === 0 ? "Please Select Category" : `Please Select Sub Category-${i}`}
                        heads={[{ 'key': 'categoryName', 'name': 'Name' },
                        { 'key': 'categoryPrefix', 'name': 'Prefix' }]}
                        details={i > 0 ? categoryDetails && categoryDetails?.filter((el) => { return el.parentId === categoryDropDown[i - 1]?.id }) : categoryDetails && categoryDetails?.filter((el) => { return el.catalogueId === filter?.catalogue?.id && el.parentId === null })}
                        parentValue={customObject(categoryDetails, data?.id)}
                        position={"top"}
                        variant={'outlined'}
                        customClasses={clsx(classes.margin20t)}
                        onChange={(data) => changeHandler(data, 'category')}
                    />
                ))
            }
        </div>
        <NavLink to={'#'}
            onClick={() => handleFindProducts()}
            className={clsx(classes.AddMoreBtn, classes.cardAddMoreBtn, { [classes.disabled]: (categoryDropDown.length === 0 || !filter?.catalogue?.id) })}
        >Apply</NavLink>
    </div>
</Popover>
        </Fragment >
    );
}